import { render, staticRenderFns } from "./TradeOrders.vue?vue&type=template&id=6394a48b"
import script from "./TradeOrders.vue?vue&type=script&lang=js"
export * from "./TradeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports